import React from 'react';
import { Card, Table } from 'antd';

interface IComponentProps {
	data?: any;
  enums?: any;
}

const RemarkDetail:React.FC<any> = (props) => {

  const { data, enums } = props || {};
  const { remarks } = data?.order_info || {};


  interface DataType {
    key: string;
    name: string;
    age: number;
    address: string;
    tags: string[];
  }
  
  const columns = [
    {
      title: '备注时间',
      dataIndex: 'time',
      key: 'time',
    },
    {
      title: '操作人',
      dataIndex: 'operate_user_name',
      key: 'operate_user_name',
    },
    {
      title: '备注内容',
      dataIndex: 'content',
      key: 'content',
    },
  ];
  
  return (
    <>
      <Card title="备注信息" style={{ marginBottom: 20 }}>
        <Table columns={columns} dataSource={remarks || []} pagination={false} />
      </Card>
    </>
  );
}

export default RemarkDetail;